import React, { useEffect, useState } from 'react'
import {
   SimpleForm,
   Create,
   NumberInput,
   TextInput,
   SelectArrayInput,
} from 'react-admin'

import { transform } from '../../../../helpers'
import { BackButton } from '../../../helperComponents/BackButton'
import { httpClient } from '../../../../config'
import { useIndustry } from '../../../../context/IndustryContext'

export const DefaultGoogleCampaignSettingsCreate = props => {
   const [reports, setReports] = useState([])
   const { industryId } = useIndustry()

   useEffect(() => {
      try {
         const doRequest = async () => {
            const response = await httpClient(`/access/data?industry_id=${industryId}`)
            const fetchedReports = JSON.parse(response.body).reportData.map(({id, report_name}) => ({
               id,
               name: report_name,
            }))
            setReports(fetchedReports)
         }

         doRequest()
      } catch (err) {
         console.log(err)
      }
   }, [industryId])

   return (
     <>
        <BackButton path="/default_google_campaign_settings"/>
        <span className="h4">Create Google default campaign</span>
        <Create {...props} title=" " transform={transform('report_ids')}>
           <SimpleForm>
              <NumberInput source="affiliate_id" label="Affiliate ID"/>
              <NumberInput source="offer_id" label="Offer ID"/>
              <TextInput source="campaign_default"/>
              <SelectArrayInput
                label="Reports"
                source="report_ids"
                choices={reports}
              />
           </SimpleForm>
        </Create>
     </>
   )
}
